<template>
  <div class="main-page process">
    <Menus title="留言咨询" :home="true">
      <a @click="$router.push('/service/10')" href="javascript:;" slot="left-link" />
    </Menus>
    <div class="container-flex">
      <div class="success-con">
        <div class="success-info">
          <div class="success-icon" />
          <div class="title">提交成功</div>
          <div class="desc">
            您可通过终端机的留言咨询查询入口、12348云南法网的用户中心查看答复内容。
            <br />也可扫描下方二维码关注"云南掌上12348"微信公众号，
            <br />在“个人法务->法律咨询->我的->我的留言咨询”中进行查看。
          </div>
          <img v-if="$store.state.device.config" :src="$store.state.device.config.web_qr_url" class="erweima" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
export default {
  components: { Menus },
}
</script>
<style lang="stylus" scoped>
.container-flex
  padding-top 0.6rem
  .success-con
    width 12rem
    border-radius 0.3rem
    padding 0.5rem 0
    margin 0.3rem auto
    background rgba(255, 255, 255, 0.2)
    border solid 1px rgba(255, 255, 255, 0.2)
</style>